import React from 'react';

const Separator = () => {
    return <div style={{ borderBottom: '1px solid #ccc', marginBottom: '20px' }} />;
};

export default Separator;



// WEBPACK FOOTER //
// ./src/assets/Separator.jsx